import { VIEW_TOP } from '../../config/gameplay';

/** Fixed-scale framing: protect the top, then return after the pile settles. */
export class CameraFraming {
  public top = VIEW_TOP;
  private lowerForMs = 0;

  public reset(): void {
    this.top = VIEW_TOP;
    this.lowerForMs = 0;
  }

  public update(contentTop: number, deltaMs: number): number {
    const dt = Math.max(0, Math.min(deltaMs, 50));
    const target = Math.min(VIEW_TOP, contentTop - 24);
    if (target < this.top) {
      this.lowerForMs = 0;
      this.top += (target - this.top) * (1 - Math.exp(-dt / 90));
      // Sudden spawns must never wait offscreen for the camera to catch up.
      this.top = Math.min(this.top, contentTop - 12);
    } else if (target - this.top > 8 || target === VIEW_TOP || this.lowerForMs >= 450) {
      this.lowerForMs += dt;
      if (this.lowerForMs >= 450) {
        this.top += (target - this.top) * (1 - Math.exp(-dt / 260));
        if (target - this.top < 0.25) {
          this.top = target;
          this.lowerForMs = 0;
        }
      }
    } else {
      this.lowerForMs = 0;
    }
    return this.top;
  }
}
